import Vue from 'vue'
import i18n from '../core'
import store from '@/$plugins/store/core'

// if store language changes, define i18n.locale by language
store.watch(() => store.getters['gui/language:get'], language => {
  Vue.set(i18n, 'locale', language)
})
